import { render, staticRenderFns } from "./ConsoleShop.vue?vue&type=template&id=cd05d84a&"
import script from "./ConsoleShop.vue?vue&type=script&lang=js&"
export * from "./ConsoleShop.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports